/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The connector type
 */
export enum ConnectorType {
  IEC_62196_T1 = 'IEC_62196_T1',
  IEC_62196_T2 = 'IEC_62196_T2',
  IEC_62196_T2_COMBO = 'IEC_62196_T2_COMBO',
  IEC_62196_T3C = 'IEC_62196_T3C',
  CHADEMO = 'CHADEMO'
}
